import { Injectable, inject } from '@angular/core';
import ModalService from '../services/modal.service';

@Injectable({ providedIn: 'root' })
export default class AngularStateHelperService {
	private modalService: ModalService = inject(ModalService);
	
	updateRouteViewStates(next) {
		this.setGlobalProperty('hasNoScroll', next.hasNoScroll);
		this.setGlobalProperty('isFullScreen', next.isFullScreen);
		this.setGlobalProperty('hasBgImage', next.hasBgImage);
		this.setGlobalProperty('ofyVisible', next.ofyVisible);
		this.setGlobalProperty('showFooterInMobile', next.showFooterInMobile);
		this.setGlobalProperty('noOffsetBottom', next.noOffsetBottom);
		
		if (next.hasNoScroll) {
			document.body.classList.add("u-no-scroll");
		} else {
			document.body.className = document.body.className.replace("u-no-scroll","");
		}
		
		if (next.ofyVisible) {
			document.body.classList.add("u-ofy-visible");
		} else {
			document.body.className = document.body.className.replace("u-ofy-visible","");
		}
		
		var main: any = document.getElementById("main");
		if (main) {
			var mainBackgroundContainer: any = document.getElementById("mainBackgroundContainer");
			var mainContentContainer: any = document.getElementById("mainBackgroundContainer");
			var mainFooterContainer: any = document.getElementById("mainFooterContainer");
			var fullScreenContainer: any = document.getElementById("fullScreenContainer");
			var fullScreenBackGroundOverlay: any = document.getElementById("backGroundOverlay");
			
			if (next.hasBgImage) {
				mainContentContainer.classList.add("c-overlay");
				fullScreenContainer.classList.add("c-bg--s1");
				fullScreenBackGroundOverlay.classList.add("c-overlay--s4");
			} else {
				mainContentContainer.className = mainContentContainer.className.replace("c-overlay","");
				fullScreenContainer.className = mainBackgroundContainer.className.replace("c-bg--s1","");
				fullScreenBackGroundOverlay.className = fullScreenContainer.className.replace("c-overlay--s4","");
			}
			
			if (next.isFullScreen) {
				fullScreenContainer.className = fullScreenContainer.className.replace("u-hidden","");
				fullScreenContainer.classList.add("c-bg--s3");
				main.className = main.className.replace("c-container","");
				main.classList.add("o-container--fluid");
			} else {
				fullScreenContainer.classList.add("u-hidden");
				fullScreenContainer.className = fullScreenContainer.className.replace("c-bg--s3","");
				main.className = main.className.replace("o-container--fluid","");
				main.classList.add("c-container");
			}
			
			if (next.isNoHeader) {
				main.className = main.className.replace("c-container","");
				main.classList.add("o-container--fluid");
			} else {
				main.className = main.className.replace("o-container--fluid","");
				main.classList.add("c-container");
			}
			
			if (next.showTabs && !next.showProfile) {
				main.classList.add("u-no-pt@medium-and-up");
			} else {
				main.className = main.className.replace("u-no-pt@medium-and-up","");
			}
			
			if (next.noOffsetBottom) {
				main.classList.add("u-no-pb@up-to-md");
			} else {
				main.className = main.className.replace("u-no-pb@up-to-md","");
			}
			
			if (!next.showFooterInMobile && !next.hasNoScroll && !next.noOffsetBottom) {
				main.classList.add("u-offset-bottom-xxl@up-to-md");
			} else {
				main.className = main.className.replace("u-offset-bottom-xxl@up-to-md","");
			}
			
			if (!next.showFooterInMobile) {
				mainFooterContainer.classList.add("u-hidden@up-to-md");
			} else {
				mainFooterContainer.className = mainFooterContainer.className.replace("u-hidden@up-to-md","");
			}
			
			this.modalService.closeAll();
		}
	}
	
	getGlobalProperty(name) {
		var _window: any = window;
		if (name && _window.globalProperties) {
			return _window.globalProperties[name];
		} else {
			return undefined;
		}
	}
	
	setGlobalProperty(name, value) {
		var _window: any = window;
		if (name === "noDocScroll") {
			var root: any = document.getElementsByTagName("html")[0];
			if (value) {
				root.classList.add("u-no-scroll");
			} else {
				root.className = root.className.replace("u-no-scroll","");
			}
		}
		if (!_window.globalProperties) {
			_window.globalProperties = {};
		}
		_window.globalProperties[name] = value;
	}

}